
import { Json } from '@/integrations/supabase/types';
import { BlogPost } from './types';

// Calculate reading time based on content length
export const calculateReadTime = (content: string[] | Json): string => {
  let wordCount = 0;
  
  if (Array.isArray(content)) {
    // Handle string array format
    const text = content.join(' ');
    wordCount = text.split(/\s+/).length;
  } else if (typeof content === 'string') {
    // Handle raw string format
    wordCount = content.split(/\s+/).length;
  } else if (content && typeof content === 'object') {
    // Handle JSONB format from Supabase
    try {
      // Join all HTML strings and count words
      const textContent = JSON.stringify(content);
      // Remove HTML tags for word counting
      const plainText = textContent.replace(/<[^>]*>/g, ' ');
      wordCount = plainText.split(/\s+/).length;
    } catch (e) {
      console.error('Error parsing content for read time calculation:', e);
    }
  }
  
  // Average reading speed: 200 words per minute
  const readTimeMinutes = Math.ceil(wordCount / 200);
  return `${readTimeMinutes}`;
};

// Helper function to transform database post to frontend format
export const transformDatabasePost = (post: any): BlogPost => {
  const contentArray = Array.isArray(post.content) 
    ? post.content 
    : typeof post.content === 'string'
      ? [post.content]
      : JSON.parse(JSON.stringify(post.content));
  
  return {
    id: post.id,
    title: post.title,
    slug: post.slug,
    excerpt: post.excerpt,
    content: contentArray,
    image: post.image,
    author: post.author,
    publish_date: post.publish_date,
    tags: post.tags,
    meta_description: post.meta_description,
    readTime: calculateReadTime(post.content)
  };
};
